(function($) {
  'use strict'; 

  var variantSelect = null;
  
  function selectedFitName()
  {
      if (variantSelect) {
        let fitOptions = variantSelect.find('.swatch-list-option-fit .SizeSwatch__Radio');
        if (fitOptions.length != 0) {
            let fit = variantSelect.find('.swatch-list-option-fit .SizeSwatch__Radio:checked').data('size-value');
            return fit;
        }
      }
      return 'standard';
  }

  function selectedSizeName()
  {
    if (variantSelect) {
      let sizeOptions = variantSelect.find(`.variations .product-form__input--block input[data-option-slug="size"]:checked`);
      if (sizeOptions.length != 0) {
        let size = sizeOptions.val();
        return size.toLowerCase();
      }
    }
    return '';
  }
  
  function updateSwatchAvailability()
  {
    $('variant-selects').each(function(){
      variantSelect = $(this);
      let fit = selectedFitName();
      let size = selectedSizeName();
      console.log("Size:", size);
      if (variantSelect) {
        variantSelect.find(`.variations .product-form__input--color .swatch-label`).addClass('not-available');
        variantSelect.find(`.variations .product-form__input--color .swatch-label[data-szav-${fit}-${size}=1]`).removeClass('not-available');
      }
    });
  }
  
  $(document).on('change', '.variations .product-form__input--block input[name="Size"]', function(){
      variantSelect = $(this).parents('variant-selects');
      updateSwatchAvailability();
  });

  $(document).on('click', '.xcvi-color-swatch-item .swatch-link', function(e){
      e.preventDefault();
      variantSelect = $(this).parents('variant-selects');
      let fit = selectedFitName();
      let size = selectedSizeName();
      let variant = $(this).data(`variant-${fit}-${size}`);
      let href = $(this).attr('href');
      window.location.replace(`${href}?variant=${variant}`);
  });

  updateSwatchAvailability();

  $(document).on('change', '.ColorSwatch__Radio', function() {
    let radio = $(this);
    let image = radio.data('featured_image');
    let alt_image = radio.data('alternate_image');
    let color_name = radio.data('color-name');
    let price = radio.data('price');
    let wrapper = radio.parents('.ProductItem__Wrapper'); 
    wrapper.find('.ProductItem__Image').attr('srcset', image);
    wrapper.find('.ProductItem__Image.ProductItem__Image--alternate').attr('srcset', alt_image);
    wrapper.find('.ProductItem__PriceList .ProductItem__Price').html(price);
    let anchor = wrapper.find('.ProductItem__Title.Heading a');
    var title = anchor.data('title');
    if (color_name) {
      title = `${title}<span class="colortitle"> in ${color_name}</span>`;
    }
    wrapper.find('.ProductItem__Title.Heading a').html(title);
  });

  const swatchDebugVerbose = false;
  let collectionHandle;
  if(document.body.classList.contains('template-collection') || true/* Retrieve swatches on any page */) {
    let page = 1;
    collectionHandle = 'all'; //window.location.pathname.split('/').filter(item => { return !!item }).at(-1);
    if (sessionStorage.getItem('collProdsFetchDate') === null) {
      sessionStorage.setItem('collProdsFetchDate', Date.now());
    }
    if (sessionStorage.getItem('collProdsPriceUpdate') === null) {
      sessionStorage.setItem('collProdsPriceUpdate', 'Yes');
      sessionStorage.removeItem('collProdsImgData');
    }
    if (sessionStorage.getItem('collProdsColorUpdate') === null) {
      sessionStorage.setItem('collProdsColorUpdate', 'Yes');
      sessionStorage.removeItem('collProdsImgData');
    }
    const fetchCollProdsSwatchDataPage = () => { 
      if(!!swatchDebugVerbose) { console.log('%c[fetchCollProdsSwatchDataPage]', 'background-color: rgba(255,0,0,0.3)'); }
      let lastFetchTime = sessionStorage.getItem('collProdsFetchDate');
      let diff = Date.now() - lastFetchTime;
      let timeThreshold = (1*60*60*1000);
      if(!!sessionStorage.getItem('collProdsImgData') && diff < timeThreshold) { 
        if(!!swatchDebugVerbose) { console.log('%cretrieved saved data', 'background-color: rgba(0,255,0,0.3)'); }
        window.collSwatchFetchComplete = true;
        return;
      }
      // if (diff > timeThreshold) {
      //   sessionStorage.setItem('collProdsImgData', '');
      // }
      fetch(`/collections/${collectionHandle}/?view=swatch-data${page > 1 ? `&page=${page}` : ''}`, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (response) {
        response.text().then(content => {
          if(!!content && content.includes('window.collProdsImgData')) { 
            if(!!swatchDebugVerbose) { 
              console.log('%cAppend fetchCollProdsSwatchDataPage script tag (' + content.length + ')', 'background-color: rgba(255,0,0,0.1)'); 
            }
            const newScriptTag = document.createElement('script');
            newScriptTag.setAttribute('class', 'script-swatch-data');
            newScriptTag.setAttribute('data-page', page);
            newScriptTag.innerHTML = content;
            document.body.appendChild(newScriptTag);
            if(!!swatchDebugVerbose) { 
              console.log('swatches', !!window.collProdsImgData ? window.collProdsImgData.split('[,]').filter(item => !!item).length : 'Not initialized'); 
            }
            page++;
            setTimeout(fetchCollProdsSwatchDataPage, 1000);
          } else {
            if(sessionStorage.getItem('collProdsImgData') === null || sessionStorage.getItem('collProdsImgData') === '') {
              sessionStorage.setItem('collProdsImgData', window.collProdsImgData);
              sessionStorage.setItem('collProdsFetchDate', Date.now());
            }
            window.collSwatchFetchComplete = true;
          }
        });
      });
    };
    fetchCollProdsSwatchDataPage();
  }
  const moreColorThreshold = 4;
  window.renderCollProdItemSwatches = ($productItem) => {
      // console.log('renderCollProdItemSwatches');
      // const $productItem = $productItemAnchor.closest('.ProductItem');
      //const productHandle = $productItemAnchor.getAttribute('href').split('/').filter(item => !!item).at(-1).split('?').at(0);
      const $sectionID = $productItem.getAttribute('data-section-id');
      const $productID = $productItem.getAttribute('data-product-id');
      // const productHandle_old = $productItemAnchor.getAttribute('href').split('/').filter(item => !!item);
      // const productHandle_old1 = productHandle_old[productHandle_old.length-1].split('?');
      const productHandle = $productItem.getAttribute('data-product-handle');//productHandle_old1[0];
      const $swatchesWrap = $productItem.getElementsByClassName('product-card-swatches')[0];
      const $swatchesWrapTitle = $productItem.getElementsByClassName('product-card-swatches--title')[0];
      let swatchItemsHTML = '';
      let swatchesShown = 0;
      let swatchesTotal = 0;
      var prodImgData = window._collProdsImgData[productHandle];
      if (prodImgData) {
          let prodImgDataRelationGroup = prodImgData[6];
          let color_name = `${$sectionID}-${$productID}`;
          if(typeof prodImgData !== 'undefined' && typeof prodImgDataRelationGroup !== 'undefined') {
          if(!!prodImgData) {
            let color_id = `${$sectionID}-${$productID}-0`;
            var swatchClass = ["product-card-swatch"];
            if (swatchesShown == 0) {
              swatchClass.push('active');
            }
            
            swatchItemsHTML += `<div class="${swatchClass.join(' ')}" data-price='${prodImgData[4]}' style="${prodImgData[1]}" data-image="${prodImgData[2]}" data-href="/products/${productHandle}">
                                    	<span class="visually-hidden">
                                    		${prodImgData[5]}
                                    	</span>
                                    </div>`;
            // swatchItemsHTML += `<div class="ProductItem__ColorSwatchItem">
            //               <input class="ColorSwatch__Radio" type="radio" data-price="${prodImgData[4]}" checked data-featured_image="${prodImgData[2]}" data-color-name="${prodImgData[5]}" data-alternate_image="${prodImgData[3]}" name="${color_name}" id="${color_id}" value="${prodImgData[0]}" data-image-url="${prodImgData[1]}" data-variant-url="/products/${productHandle}">
            //               <label class="ColorSwatch ColorSwatch--small" for="${color_id}" style="${prodImgData[1]}" title="${prodImgData[0]}" data-tooltip="${prodImgData[0]}"></label>
            //             </div>`;
            // swatchItemsHTML += `<a class="ProductItem__Swatches--Item 123 ProductItem__Swatches--Item-active" href="/collections/${collectionHandle}/products/${productHandle}" style="background-image: url(${prodImgData[1]})" data-thumb="${prodImgData[2]}" data-thumbalt="${prodImgData[3]}" title="Color: ${prodImgData[0]}"></a>`;
            swatchesShown++;
            swatchesTotal++;
          }
          // console.log(prodImgDataRelationGroup);
          prodImgDataRelationGroup = prodImgDataRelationGroup.split(',');
          prodImgDataRelationGroup.forEach((groupItem, loopIndex) => {
            let color_id = `${$sectionID}-${$productID}-${loopIndex + 1}`;
            if(typeof window._collProdsImgData[groupItem] !== 'undefined') {
              let prodImgData = window._collProdsImgData[groupItem];
              if(swatchesShown < moreColorThreshold && !!prodImgData && groupItem !== productHandle) {
                var swatchClass = ["product-card-swatch"];
                if (swatchesShown == 0) {
                  swatchClass.push('active');
                }
                swatchItemsHTML += `<div class="${swatchClass.join(' ')}" data-price='${prodImgData[4]}' style="${prodImgData[1]}" data-image="${prodImgData[2]}" data-href="/products/${groupItem}">
                                    	<span class="visually-hidden">
                                    		${prodImgData[5]}
                                    	</span>
                                    </div>`;
                // swatchItemsHTML += `<div class="ProductItem__ColorSwatchItem">
                //           <input class="ColorSwatch__Radio" type="radio" data-price="${prodImgData[4]}" data-featured_image="${prodImgData[2]}" data-color-name="${prodImgData[5]}" data-alternate_image="${prodImgData[3]}" name="${color_name}" id="${color_id}" value="${prodImgData[0]}" data-image-url="${prodImgData[1]}" data-variant-url="/products/${groupItem}">
                //           <label class="ColorSwatch ColorSwatch--small" for="${color_id}" style="${prodImgData[1]}" title="${prodImgData[0]}" data-tooltip="${prodImgData[0]}"></label>
                //         </div>`;
                // swatchItemsHTML += `<a class="ProductItem__Swatches--Item" href="/collections/${collectionHandle}/products/${groupItem}" style="background-image: url(${relImgData[1]})" data-thumb="${relImgData[2]}" data-thumbalt="${relImgData[3]}" title="Color: ${relImgData[0]}"></a>`;
                swatchesShown++;
              }
              swatchesTotal++;
            }
          });
          if(swatchesTotal > moreColorThreshold) {
            let more_count = (swatchesTotal - 1) - moreColorThreshold;
            var more_info = '';
            if (more_count == 0) {
              more_info = ''
            }else if (more_count == 1) {
              more_info = `+${more_count} color`;
            }else{
              more_info = `+${more_count} colors`;
            }
            swatchItemsHTML += `<a href="/products/${productHandle}" class="productitem-swatches-count">${more_info}</a>`;
          }
        }
        if(!!swatchItemsHTML && $swatchesWrap) {
          $swatchesWrap.innerHTML = swatchItemsHTML;
          // console.log($swatchesWrapTitle);
          var total_color_count = '';
          let total_count = swatchesTotal - 1;
          if (swatchesTotal == 0) {
            total_color_count = ``;
          }else if (swatchesTotal == 1) {
            total_color_count = `${total_count} color`;
          }else{
            total_color_count = `${total_count} colors`;
          }
          var t_html = $swatchesWrapTitle.innerHTML;
          let old_count = $swatchesWrapTitle.getAttribute('data-count');
          t_html = t_html.replace(`${old_count} colors`, `${total_color_count}`);
          t_html = t_html.replace(`${old_count} color`, `${total_color_count}`);
          $swatchesWrapTitle.innerHTML = t_html;
          // $productItemAnchor.parentNode.insertBefore($swatchesWrap, $productItemAnchor.nextSibling);
          const swatchItemMouseOverHandler = event => {
            if(event.type == 'click' && $(window).width() <= 767) {
              event.preventDefault();
            }
            const $target = event.target;
            let targetImage = $target.getAttribute('data-image');
            // window.location.href = $target.getAttribute('data-href');
            // const targetHref = $target.getAttribute('href');
            const $productItem = $target.closest('.product-card');
            let productImage = $productItem.getElementsByClassName('product-primary-image')[0];
            productImage.setAttribute('srcset', targetImage);
            // $productItem.data = { swatchTarget: $target };
            // $productItem.querySelectorAll('.ProductItem__ImageWrapper, .ProductItem__Info a').forEach(productItemAnchor => {
            //   productItemAnchor.setAttribute('href', targetHref);
            // });
            // const $imgPrimary = $productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
            // const $imgAltenate = $productItem.querySelector('.ProductItem__Image.ProductItem__Image--alternate');
            // updateProductItemImage($imgPrimary, $target.getAttribute('data-thumb'), $target);
            // updateProductItemImage($imgAltenate, $target.getAttribute('data-thumbalt'), $target);
          };
          const swatchItemMouseLeaveHandler = event => {
            if(event.type == 'click' && getWindowWidth() <= 767) {
              event.preventDefault();
            }
            const $target = event.target;
            let targetImage = $target.getAttribute('data-image');
            // window.location.href = $target.getAttribute('data-href');
            // const targetHref = $target.getAttribute('href');
            const $productItem = $target.closest('.product-card');
            let productImage = $productItem.getElementsByClassName('product-primary-image')[0];
            productImage.setAttribute('srcset', productImage.getAttribute('data-srcset'));
            // $productItem.data = { swatchTarget: $target };
            // $productItem.querySelectorAll('.ProductItem__ImageWrapper, .ProductItem__Info a').forEach(productItemAnchor => {
            //   productItemAnchor.setAttribute('href', targetHref);
            // });
            // const $imgPrimary = $productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
            // const $imgAltenate = $productItem.querySelector('.ProductItem__Image.ProductItem__Image--alternate');
            // updateProductItemImage($imgPrimary, $target.getAttribute('data-thumb'), $target);
            // updateProductItemImage($imgAltenate, $target.getAttribute('data-thumbalt'), $target);
          };
          $swatchesWrap.querySelectorAll('.product-card-swatch').forEach($swatchItem => {
            $swatchItem.addEventListener('mouseover', swatchItemMouseOverHandler);
            $swatchItem.addEventListener('mouseleave', swatchItemMouseLeaveHandler);
            // $swatchItem.addEventListener('click', swatchItemMouseOverHandler);
          });
          const $productItemImgPrimary = $productItem.querySelector('.ProductItem__Image:not(.ProductItem__Image--alternate)');
          // $productItemImgPrimary.onload = function() {
          //   const $productItem = this.closest('.ProductItem');
          //   if(!!$productItem.data
          //   && !!$productItem.data.swatchTarget) {
          //     setProductItemSwatchActive($productItem.data.swatchTarget);
          //   }
          // };
        }
  
        let color = !!window._collProdsImgData[productHandle] ? 'color: green' : 'color: red';
        if(!!swatchDebugVerbose) { console.log('%c'+productHandle, color); }
      }
      $productItem.classList.add('swatches-set');
    };
  
    window.renderCollProdsSwatches = () => {
      if(window.collSwatchFetchComplete) {
        const savedCollProdsImgData = sessionStorage.getItem('collProdsImgData') || window.collProdsImgData;
        window._collProdsImgData = {};
        savedCollProdsImgData.split('[,]').filter(item => !!item).forEach(item => {
          let items = item.split('[.]');
          let handle = items.shift();
          window._collProdsImgData[handle] = items;
        });
        document.querySelectorAll('.product-card:not(.swatches-set)').forEach(item => {
          if(item.closest('[data-section-type="recently-viewed-products"]') === null) {
            // console.log('renderCollProdsSwatches Complete 1');
            renderCollProdItemSwatches(item);
          }
        });
      }
    };
    // if(document.body.classList.contains('template-collection') || document.body.classList.contains('template-search')) {
    //   setInterval(window.renderCollProdsSwatches, 1000);
    // }
    setInterval(window.renderCollProdsSwatches, 1000);

  $(document).on('change', 'select[name=id]', function() {
      changePresaleInfo();
  });

  const upperize = obj => Object.keys(obj).reduce((acc, k) => {
    acc[k.toUpperCase()] = obj[k];
    return acc;
  }, {});
  
  function changePresaleInfo()
  {
      var sku = $('select[name=id] option:selected').data('sku');
      if (sku) {
        sku = sku.toUpperCase();
        let variant = $('select[name=id]').val();
        let size = selectedSizeName().toUpperCase();
        let presale_info = $('.presale-info');
        if (presale_info) {
          var presale = presale_info.data('presale');
          presale = upperize(presale);
          var presale_text = presale_info.data('presale-text');
          presale_text = presale_text.replace('##size##', size);
          $('.presale-info .Presale__Text').html(presale_text);
          let v = $(`.presale-variant-info[data-variant=${variant}]`);
          if (v) {
            let v_q = v.data('quantity');
            if (v_q <= presale[sku]) {
              updateCartButtonAndPresaleInfo(true)
            }else{
              updateCartButtonAndPresaleInfo(false)
            }
          }else{
            updateCartButtonAndPresaleInfo(false)
          }
        }else{
          updateCartButtonAndPresaleInfo(false)
        }
      }
  }

  function updateCartButtonAndPresaleInfo(show = false)
  {
      let cart_btn_text = $('.presale-info').data('cart-btn-text');
      let presale_btn_text = $('.presale-info').data('presale-btn-text');
      
      if (show) {
        $('.presale-info').show();
        $('.ProductForm__AddToCart.Button[data-action=add-to-cart] span').html(presale_btn_text);
        $('.ProductForm__AddToCart.Button[data-action=add-to-cart]').addClass('presale-active');
      }else{
        $('.presale-info').hide();
        $('.ProductForm__AddToCart.Button[data-action=add-to-cart] span').html(cart_btn_text);
        $('.ProductForm__AddToCart.Button[data-action=add-to-cart]').removeClass('presale-active');
      }
  }
  
  changePresaleInfo();
  
  $(document).on('click', '.variations .product-form__input--color .swatch-label', function(e){
    e.preventDefault();
    variantSelect = $(this).parents('variant-selects');
    let element = $(this);
    let href = element.data('handle');
    let fit = selectedFitName();
    let size = selectedSizeName();
    let variant = $(this).data(`variant-${fit}-${size}`);
    let sidePanel = $(this).parents('.side-panel');
    console.log(variant, fit, size);
    if (sidePanel.length != 0) {
      window.location.href = `${href}?variant=${variant}`;
    }else{
      window.location.replace(`${href}?variant=${variant}`);
    }
  });

  $(document).on('mouseenter', '.product-card-swatch', function(){
    let swatch = $(this);
    let price = swatch.data('price');
    let productCard = swatch.parents('.product-card');
    let insAmountSpan = productCard.find('span.price ins span.amount');
    let delAmountSpan = productCard.find('span.price del span.amount');
    insAmountSpan.html(price);
    if (delAmountSpan.length != 0) {
      let insP = strip_tags(insAmountSpan.html()).trim();
      let delP = strip_tags(delAmountSpan.html()).trim();
      if (insP == delP) {
        productCard.find('span.price').addClass('hide-del');
      }
    }
  });
  $(document).on('mouseleave', '.product-card-swatch', function(){
    let swatch = $(this);
    let productCard = swatch.parents('.product-card');
    let insAmountSpan = productCard.find('span.price ins span.amount');
    let delAmountSpan = productCard.find('span.price del span.amount');
    let price = insAmountSpan.data('original-price');
    insAmountSpan.html(price);
    if (delAmountSpan.length != 0) {
      let insP = strip_tags(insAmountSpan.html()).trim();
      let delP = strip_tags(delAmountSpan.html()).trim();
      if (insP != delP) {
        productCard.find('span.price').removeClass('hide-del');
      }
    }
  });

  $(document).on('click', '.product-card-swatch', function(){
    let swatch = $(this);
    let href = swatch.data('href');
    console.log(href);
    if (href.length != 0) {
      window.location.href = `${href}`;
    }
    // let productCard = swatch.parents('.product-card');
    // let amountSpan = productCard.find('span.price span.amount');
    // let price = amountSpan.data('original-price')
    // amountSpan.html(price);
  });

  function onElementInserted(containerSelector, elementSelector, callback) {

    var onMutationsObserved = function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                var elements = $(mutation.addedNodes).find(elementSelector);
                for (var i = 0, len = elements.length; i < len; i++) {
                    callback(elements[i]);
                }
            }
        });
    };

    var target = $(containerSelector)[0];
    var config = { childList: true, subtree: true };
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new MutationObserver(onMutationsObserved);    
    observer.observe(target, config);

}

onElementInserted('body', 'variant-selects', function(element) {
    updateSwatchAvailability();
});
function strip_tags(str, allow){
 // making sure the allow arg is a string containing only tags in lowercase (<a><b><c>)
 allow = (((allow || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');

 var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
 var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
 return str.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
 return allow.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 :'';
 });
}
})(jQuery);